import React, {FC} from 'react';
import {Subject} from 'rxjs';

import {AppPanelId} from '../../libs/shared/core/src/store/panels/panelStateBase';
import {Layer} from '../../libs/shared/ui/src/components/layers/layer';
import {GlobalStyles} from '../../libs/shared/ui/src/styles/globalStyles';
import {SingleUseValue} from '../helpers/memoryHelpers';
import {AppBanners} from './app/banners/appBanners';
import {OnboardingModalProvider} from './app/topBar/onboarding/onboardingHooks';
import {AppChat} from './appChat';
import {AppContentContainer} from './appContentContainer';
import {ElectronUICapabilities} from './electronUICapabilities';
import {ErrorReporterContainer} from './errors/errorReporterContainer';
import {AppGrammarlyButtonHost} from './grammarly/appGrammarlyButtonHost';
import {GoogleAnalyticsFrame} from './inboxes/googleAnalyticsFrame';
import {LegacyFrameRawBoot} from './legacy/legacyFrameHelpers';
import {AdminWizardPopoverContainer} from './onboarding/admin/wizard/adminWizardPopoverContainer';
import {OnboardingWelcomeContainer} from './onboarding/welcome/onboardingWelcomeContainer';
import {PopupsContainer} from './popups/popupsContainer';
import {SessionTimeoutDialog} from './sessionTimeoutDialog';
import {TitleContainer} from './title/titleContainer';

/*
 * Props.
 */

interface AppProps {
  panelId: AppPanelId;
  rawBoot$?: Subject<LegacyFrameRawBoot>;
  initialRawBoot?: SingleUseValue<unknown>;
}

/*
 * Component.
 */

export const App: FC<AppProps> = ({panelId, rawBoot$, initialRawBoot}) => (
  <>
    <GlobalStyles />
    <ElectronUICapabilities />
    <TitleContainer />
    <SessionTimeoutDialog />
    <OnboardingModalProvider>
      <Layer testId="app-content">
        <AppContentContainer panelId={panelId} rawBoot$={rawBoot$} initialRawBoot={initialRawBoot} />
      </Layer>
      <AppBanners panelId={panelId} />

      <Layer testId="popups">
        <PopupsContainer />
      </Layer>
      <OnboardingWelcomeContainer panelId={panelId} />
      <AdminWizardPopoverContainer panelId={panelId} />

      <Layer testId="grammarly">
        <ErrorReporterContainer isTopLevel={false}>
          <AppGrammarlyButtonHost panelId={panelId} />
        </ErrorReporterContainer>
      </Layer>
    </OnboardingModalProvider>

    <AppChat panelId={panelId} />
    <ErrorReporterContainer isTopLevel={false}>
      <GoogleAnalyticsFrame />
    </ErrorReporterContainer>
  </>
);
